import { Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimePickerComponent),
      multi: true,
    },
  ],
})
export class DatetimePickerComponent implements ControlValueAccessor {
  @Input() minDate: Date;
  @Input() maxDate: Date;

  private _hoursInteval: hoursInteval = 1;
  private _minutesInterval: minutesInterval = 5;

  @Input()
  disabled: boolean;

  @Input()
  hidden: boolean;

  @Input()
  inline: boolean;

  @Input()
  set hoursInterval(value: hoursInteval) {
    this._hoursInteval = value || 1;
    this.initTimes();
  }

  @Input()
  set minutesInterval(value: minutesInterval) {
    this._minutesInterval = value || 5;
    this.initTimes();
  }

  private _date: Date;
  get date(): Date {
    return this._date;
  }

  set date(value: Date) {
    this._date = value;
    this.onChange();
  }

  private _time: any;
  get time(): any {
    return this._time;
  }

  set time(value: any) {
    this._time = value;
    this.onChange();
  }

  public times: any[];

  private propagateChange = (_: any) => {};

  constructor() {
    this._hoursInteval = 1;
    this._minutesInterval = 5;

    this.initTimes();
  }

  writeValue(obj: any): void {
    this._date = null;
    this._time = null;
    if (obj) {
      let dateTime = moment(obj);

      this._time = { hours: dateTime.hours(), minutes: dateTime.minutes() };
      this._date = moment(dateTime).startOf('day').toDate();
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private initTimes() {
    this.times = ((): any[] => {
      let res = [];
      for (let hour = 0; hour < 24; hour += this._hoursInteval) {
        for (let minute = 0; minute < 60; minute += this._minutesInterval) {
          res.push({
            label: `${leftPad(hour, 2)}:${leftPad(minute, 2)}`,
            value: { hours: hour, minutes: minute },
          });
        }
      }
      return res;
    })();

    function leftPad(number: number, targetLength: number) {
      let output = number + '';
      while (output.length < targetLength) {
        output = '0' + output;
      }
      return output;
    }
  }

  private onChange() {
    if (this.propagateChange) {
      if (!this._time) {
        this._time = { hours: moment(this._date).hours(), minutes: moment(this._date).minutes() };
      }

      let datetime = moment(this._date)
        .hours(this._time.hours)
        .minutes(this._time.minutes)
        .toDate();
      this.propagateChange(datetime);
    }
  }
}

export type hoursInteval = 1 | 2 | 3 | 6 | 12;
export type minutesInterval = 1 | 5 | 10 | 20 | 30 | 60;
